import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the filter history movement view.
 * @extends JetView
 */
export default class FilterHistoryMovementView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Player ID
                            name: 'PlayerId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text', // Text input for Datepicker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting dates
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Restricting max date to today
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for External ID
                            name: 'ExternalId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Externo'),
                            labelPosition: 'top',
                            placeholder: _('ID Externo'),
                        },
                        {
                            view: 'combo', // Combo box for Movement selection
                            name: 'Movement',
                            label: _('Movimiento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: ' ', value: _('Todos') },
                                { id: '1', value: _('Entrada') },
                                { id: '2', value: _('Salida') },
                            ],
                            value: '',
                        },
                        {
                            view: 'combo', // Combo box for Type selection
                            name: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: ' ', value: _('Todos') },
                                { id: '20', value: _('Apuestas Deportivas') },
                                { id: '30', value: _('Apuestas Casino') },
                                {
                                    id: '31',
                                    value: _('Apuestas Casino en vivo'),
                                },
                                { id: '50', value: _('Regalo Redimido') },
                            ],
                            value: '',
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Gets form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Conditional deletion of Date field
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Conditional deletion of Datepicker field
                                    }
                                }
                                this.app.callEvent('historyPoints:filter', [
                                    filterdata, // Calls event with filter data
                                ]);
                                $$('b5').collapse(); // Collapses the filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear filters in popup
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the popup form
                    },
                },
                {
                    view: 'button', // Button to consult/filter data in popup
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Gets form values from popup
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Conditional deletion of Date field
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Conditional deletion of Datepicker field
                            }
                        }
                        this.app.callEvent('historyPoints:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                        $$('filterPopup').hide(); // Hides the popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Closes the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Conditional rendering of accordion section
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hides Date input based on profile
                $$('Datepicker').show(); // Shows Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Shows Date input
                    $$('Datepicker').hide(); // Hides Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Gets current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Sets date modal based on language
        });
    }
}

// FILE DOCUMENTED
